import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'material-ui/Grid';
import { withStyles } from 'material-ui/styles/index';
import SectionTitle from '../../../common/components/Typography/SectionTitle';
import DrawerDivider from '../../../common/components/Drawer/DrawerDivider';
import GridItem from '../../../common/components/Drawer/GridItem';

const styles = () => ({
    root: {
        marginLeft: '24px',
    },
});

function ApplicantsDetails(props) {
    return (
        <div>
            <DrawerDivider />
            <div className={props.classes.root}>
                <SectionTitle>
                    Applicant details
                </SectionTitle>
                <Grid
                    className={props.classes.grid}
                    container
                    spacing={0}
                >
                    <GridItem
                        caption="Name"
                    >
                        {props.applicant.name}
                    </GridItem>
                    <GridItem
                        caption="Surname"
                    >
                        {props.applicant.surname}
                    </GridItem>
                    <GridItem
                        caption="Date of birth"
                    >
                        {props.applicant.dateOfBirth}
                    </GridItem>
                    <GridItem
                        caption="City"
                    >
                        {props.applicant.address.city}
                    </GridItem>
                    <GridItem
                        caption="Postal code"
                    >
                        {props.applicant.address.postalCode}
                    </GridItem>
                    <GridItem
                        caption="Street"
                    >
                        {props.applicant.address.street}
                    </GridItem>
                    <GridItem
                        caption="House number"
                    >
                        {props.applicant.address.houseNumber}
                    </GridItem>
                    <GridItem
                        caption="Email"
                    >
                        {props.user.mail}
                    </GridItem>
                </Grid>
            </div>
        </div>
    );
}

ApplicantsDetails.propTypes = {
    applicant: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ApplicantsDetails);



// WEBPACK FOOTER //
// ./src/app/FormStepper/Drawer/components/ApplicantDetails.js